import component from './stock.component';

let module = angular.module('stock', [])
	.component('stock', component)
	.name;

export default module;



// WEBPACK FOOTER //
// ./app/components/stock/stock.js